import React, { ReactNode, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setReduxState } from "../../redux/actions/SetReduxStateAction";

/**
 * Wrapper to update the page context whenever locale changes
 * @param param0
 * @returns
 */
function LocaleWrapper({
  locale,
  defaultLocale,
  children,
}: {
  locale: string;
  defaultLocale: string;
  children: ReactNode;
}) {
  const reduxState = useSelector((state: any) => state?.reduxState);
  const dispatch = useDispatch();
  const { locale: existingLocale, defaultLocale: existingDefaultLocale } =
    reduxState;

  useEffect(() => {
    // Whenever the locale changes, set it to redux state
    if (existingLocale !== locale || defaultLocale !== existingDefaultLocale) {
      dispatch(
        setReduxState({
          locale,
          defaultLocale,
        })
      );
    }
  }, [locale, defaultLocale]);

  return <> {children}</>;
}

export default LocaleWrapper;
